import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TableColumn} from '../table-component/table-component';
import {filterByFields} from '@/app/utils/filter-utils';
import {NgClass} from '@angular/common';


export interface ActionIcon {
  label: string;
  icon: string;
  action: (item: any) => void;
}
@Component({
  selector: 'app-table-with-inputs-component',
  standalone: true,
  imports: [
    FormsModule,
    NgClass
  ],
  templateUrl: './table-with-inputs-component.html',
  styleUrl: './table-with-inputs-component.scss'
})
export class TableWithInputsComponent {

  editingId: number | null = null;
  backupItem: any = null;
  @Input() data: any[] = [];
  @Input() labelForSearch: string = '';
  @Input() nameSeccion: string = '';
  @Input() columns: TableColumn[] = [];
  @Input() editMode: boolean = false;
  @Input() actionsIcons: ActionIcon[] = [];

  @Input() onAdd: () => void = () => {};
  @Output() addSingle = new EventEmitter<void>();
  @Output() addBulk = new EventEmitter<void>();
  @Input() onEdit!: (item: any) => void;

  @Output() saveItem = new EventEmitter<any>();
  @Output() eliminar = new EventEmitter<any>();
  onDelete(item: any) {
    this.eliminar.emit(item);
  }

  //para la busqueda de datos
  filterData: any[] = [];
  searchTerm: string = '';
  filters: string [] = [];
  columnsExcludes = ['activo', 'acciones'];

  // Paginación
  paginatedData: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  totalPages: number = 0;

  ngOnChanges() {
    this.filterData = [...this.data];
    this.filters = this.columns
      .filter(column => !this.columnsExcludes.includes(column.key))
      .map(column => column.key);
    this.updatePaginatedData();
  }

  updatePaginatedData(): void {
    this.totalItems = this.filterData.length;
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.filterData.slice(startIndex, endIndex);

    if (this.currentPage > this.totalPages && this.totalPages > 0) {
      this.currentPage = this.totalPages;
      this.updatePaginatedData();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedData();
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedData();
    }
  }

  onItemsPerPageChange(): void {
    this.currentPage = 1;
    this.updatePaginatedData();
  }

  getEndItemIndex(): number {
    const endIndex = this.currentPage * this.itemsPerPage;
    return Math.min(endIndex, this.totalItems);
  }

  startEdit(item: any) {
    this.editingId = item.id;
    this.backupItem = { ...item };
  }

  cancel() {
    if (this.backupItem && this.editingId !== null) {
      const itemInFilterData = this.filterData.find(i => i.id === this.editingId);
      if (itemInFilterData) {
        Object.assign(itemInFilterData, this.backupItem);
      }
    }
    this.editingId = null;
    this.backupItem = null;
  }

  onSaveEdit(item: any) {
    this.saveItem.emit(item);
    this.editingId = null;
    this.backupItem = null;
  }

  // Propiedades para selección
  selectedItems: Set<any> = new Set<any>();
  allSelected: boolean = false;

  // Lógica para selección
  toggleSelectAll() {
    if (this.allSelected) {
      // Deseleccionar todos
      this.data.forEach((item) => this.selectedItems.delete(item));
      this.allSelected = false;
    } else {
      // Seleccionar todos los registros visibles
      this.data.forEach((item) => this.selectedItems.add(item));
      this.allSelected = true;
    }
  }

  toggleSelectItem(item: any) {
    if (this.selectedItems.has(item)) {
      this.selectedItems.delete(item);
    } else {
      this.selectedItems.add(item);
    }
    this.updateSelectionState();
  }

  updateSelectionState() {
    const totalVisible = this.data.length;
    const selectedCount = this.data.filter((item) =>
      this.selectedItems.has(item)
    ).length;

    if (selectedCount === 0) {
      this.allSelected = false;
    } else this.allSelected = selectedCount === totalVisible;
  }

  applyFilter(): void {
    this.filterData = filterByFields(this.data, this.searchTerm, this.filters);
    this.currentPage = 1;
    this.updatePaginatedData();
  }


  isSelected(item: any): boolean {
    return this.selectedItems.has(item);
  }

  trackByIds(index: number, item: any): string {
    if (item.id) return `id_${item.id}`;
    if (item.publicId) return `public_${item.publicId}`;
    return `index_${index}`;
  }

}
